import { InputAdornment, TextField } from "@mui/material";

function TextFieldDisabled({ title, value, initialSign }) {
  return (
    <>
      <TextField
        sx={{
          m: 3,
          width: "90%",
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#000000",
          },
        }}
        id="standard-basic"
        label={title}
        variant="standard"
        InputProps={
          initialSign && {
            startAdornment: (
              <InputAdornment position="start">{initialSign}</InputAdornment>
            ),
          }
        }
        InputLabelProps={{ shrink: true }}
        value={value}
        multiline
        disabled
      />
    </>
  );
}

export { TextFieldDisabled };
